import { AstraParagraph } from '~/astra'
import { useIsPredictedWaitingListEnabled } from '~/hooks/usePractitionerPredictedWaitingList'
import { useStore } from '~/store/store'
import { Practitioner } from '~/storm'

import { CurrentWaitingList } from './CurrentWaitingList'
import { PredictedWaitingList } from './PredictedWaitingList'

type Props = {
    practitioner: Practitioner
}

export const PractitionerPreviewContent = ({ practitioner }: Props) => {
    const selectedDate = useStore(state => state.appFilters.selectedDate)
    const { enabled: predictedWaitingListEnabled } = useIsPredictedWaitingListEnabled()

    return (
        <div className="flex flex-col gap-1.5">
            <AstraParagraph className="text-muted">Venteliste for operasjon</AstraParagraph>
            <CurrentWaitingList practitioner={practitioner} />
            {predictedWaitingListEnabled && <PredictedWaitingList practitioner={practitioner} date={selectedDate} />}
        </div>
    )
}
